<template>
    <b-modal v-model="internalShow" @hide="$emit('update:show', false)" :title="$t('pickup.sendLoadingList')">
        <div class="alert alert-info">
            {{ $t('booking.thisIsOnlyLoadingList') }}
        </div>

        <div class="form-group">
            <label class="form-text">{{ $t('pickup.fields.loadingListDate') }}<required-icon></required-icon></label>
            <date-picker
                :lang="datepickerLang"
                class="w-100"
                v-model="date"
                format="DD/MM/YY"
                valueType="YYYY-MM-DD"
                type="date"
                placeholder=""
                :disabled-date="dateDisabled"
            ></date-picker>
            <span class="text-danger" v-if="errors['date']">{{ errors['date'][0] }}</span>
        </div>

        <div class="form-group">
            <label class="form-text">{{ $t('pickup.fields.emailForLoadingList') }}
                <required-icon></required-icon>
            </label>
            <input type="text" class="form-control" v-model="email"/>
            <span class="text-danger" v-if="errors['email']">{{ errors['email'][0] }}</span>
        </div>

        <template v-slot:modal-footer>
            <button class="btn btn-primary" @click="sendLoadingList">{{ $t('pickup.sendLoadingList') }}</button>
        </template>
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import DatePicker from 'vue2-datepicker'

export default {
    name: 'PickupLoadingListModal',
    components: { BModal,  DatePicker },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        bookings: {
            type: Array,
            default: () => [],
        },
    },
    data: function () {
        return {
            datepickerLang: document.documentElement.lang.substr(0, 2),
            internalShow: false,
            email: null,
            date: null,
            errors: [],
        }
    },
    watch: {
        show: {
            handler: function (val) {
                this.internalShow = val
            },
            immediate: true,
        },
    },
    methods: {
        dateDisabled(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date < today
        },
        sendLoadingList () {
            axios.post('/pickup/send-loading-list-only', { email: this.email, date: this.date, bookingIds: this.bookings.map((x) => x.id) }).then(response => {
                window.location = '/bookings?success'
            }).catch((err) => {
                this.errors = err.response.data.errors
            })
        },
    },
}
</script>
